import './styles.css'
import React from 'react'

const MultiOptionToggleBtnGroup = ({ options = [], defaultValue, onChange, disabled }) => {
  const [active, setActive] = React.useState(defaultValue || options[0] || null)

  const handleClick = label => {
    setActive(label)
    if (onChange) {
      onChange(label)
    }
  }

  return (
    <div className="toggle-container" role="group">
      {options.map(({ key, label, titleText }) => (
        <button
          type="button"
          key={key}
          className={`toggle-btn ${active === label ? 'active' : ''}`}
          onClick={() => handleClick(label)}
          title={titleText}
          disabled={disabled}
          aria-pressed={active === label}
        >
          {label}
        </button>
      ))}
    </div>
  )
}

export default MultiOptionToggleBtnGroup
